import { render, staticRenderFns } from "./spreadDialog.vue?vue&type=template&id=ad065498&scoped=true"
import script from "./spreadDialog.vue?vue&type=script&lang=js"
export * from "./spreadDialog.vue?vue&type=script&lang=js"
import style0 from "./spreadDialog.vue?vue&type=style&index=0&id=ad065498&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad065498",
  null
  
)

export default component.exports